// eslint-disable-next-line import/prefer-default-export
export enum InputTypes {
  TEXT = 'text',
  PASSWORD = 'password',
  EMAIL = 'email',
  NUMBER = 'number'
}
